import PageHero from "../components/PageHero";
import Schools from "../components/sections/Schools";
import WhatWeDo from "../components/sections/WhatWeDo";
import { CALENDLY_URL } from "../lib/site";

export default function SchoolsPage() {
  return (
    <div data-testid="schools-page">
      <PageHero
        eyebrow="For Schools"
        accent="#0055FF"
        title={
          <>
            Bring future-ready{" "}
            <span className="bg-[#FFD700] px-2 inline-block">learning</span>{" "}
            into everyday classrooms.
          </>
        }
        intro="From strategy to teacher confidence to student showcases — we partner with schools on the whole journey."
        ctaLabel="Book a Discovery Call"
        ctaTo={CALENDLY_URL}
        ctaExternal
        secondaryLabel="Send us a brief"
        secondaryTo="/contact"
      />
      <Schools />
      <WhatWeDo />
    </div>
  );
}
